import React from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import CSVExporterFactory from '../../managers/csv_export/csv_exporter_factory'
import { Toolbar, ToolbarItem } from '../common/toolbar/toolbar'
import CSVExport from '../csv_export'

const statuses = {
  All: null,
  Active: true,
  Inactive: false,
}

const parents = {
  All: null,
  'Has Parent': true,
  'Does Not Have Parent': false,
}

const AccessCodesSearchBar = (props) => {
  const handleChange = (e) => {
    const filter = { ...props.filter, code: e.target.value }
    props.updateFilter(filter)
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    const { filter } = props
    props.updateFilter(filter)
    props.onSearch(filter)
  }

  const handleSearchReset = (e) => {
    const filter = {
      code: '',
      is_active: null,
      is_notnull: null,
      is_null: null,
    }
    props.updateFilter(filter)
    props.onReset()
  }

  const handleEnterKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit(e)
    }
  }

  const getDeepLink = () => {
    const { code } = props.filter
    const [subdomain] = window.location.hostname.split('.')
    if (subdomain === 'dev-compliance' || subdomain === 'localhost') {
      return `https://dev.myverify.info/?service_code=${code}`
    } else if (subdomain === 'qa-compliance') {
      return `https://qa.myverify.info/?service_code=${code}`
    } else {
      return `https://myverify.info/?service_code=${code}`
    }
  }
  const { count, requestUrl, header } = props
  return (
    <Toolbar columns={4}>
      <ToolbarItem className={'input-group'}>
        <input
          onKeyPress={handleEnterKeyPress}
          className='form-control'
          placeholder='Code'
          value={props.filter.code}
          onChange={handleChange}
        />
        <button className='btn btn-default' type='button' onClick={handleSearchSubmit}>
          Search
        </button>
        <button className='btn btn-default' type='button' onClick={handleSearchReset}>
          Reset
        </button>
        <CopyToClipboard text={getDeepLink()}>
          <button className='btn btn-default' type='button'>
            Copy Link
          </button>
        </CopyToClipboard>
      </ToolbarItem>
      <ToolbarItem className={'input-group'}>
        <select
          value={props.filter.is_active}
          className='form-control'
          onChange={({ target }) => {
            const filter = { ...props.filter, is_active: target.value }
            props.updateFilter(filter)
            props.onSearch(filter)
          }}
        >
          {Object.entries(statuses).map(([status, value], i) => (
            <option key={i} value={value}>
              {status}
            </option>
          ))}
        </select>
      </ToolbarItem>
      <ToolbarItem className={'input-group'}>
        <select
          value={props.filter.is_notnull}
          className='form-control'
          onChange={({ target }) => {
            const filter = { ...props.filter, is_notnull: target.value }
            props.updateFilter(filter)
            props.onSearch(filter)
          }}
        >
          {Object.entries(parents).map(([parent, value], i) => (
            <option key={i} value={value}>
              {parent}
            </option>
          ))}
        </select>
      </ToolbarItem>
      <ToolbarItem className={'input-group'} style={{ flex: 1, paddingRight: 5 }} last={true}>
        <CSVExport exporter={CSVExporterFactory.ACCESS_CODES} header={header} count={count} url={requestUrl} />
      </ToolbarItem>
    </Toolbar>
  )
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AccessCodesSearchBar))
